export default "__VITE_ASSET__636e2228__"